module.exports = __webpack_public_path__ + "static/media/two_circles.15411901.svg";